const moduleApp={
    state: {
        loading:false,
        fahuonums:''    
    },
    mutations: {
        SHOW_LOADING:(state)=>{
            state.loading=true
        },
        HIDE_LOADING:(state)=>{
            state.loading=false
        },
        SET_FAHUONUMS:(state,payload)=>{
            state.fahuonums=payload.fahuonums
        }
    }
}

export default moduleApp